import { endpoints } from '../Constants';
import { authHeader } from '../Helpers';
import handleResponse from './helpers';

const gstCodeServices = {
	getGstCodes,
	createGstCode,
	deleteGstCode,
};

function getGstCodes() {
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
	};
	return fetch(endpoints.FETCH_GST_CODES, requestOptions).then(handleResponse);
}

// Upsert by gstCode. `igst` carries the full tax percentage (the backend
// stores it as taxPercentage); cgst/sgst are half of it and igst equals it,
// which the console derives for display only.
function createGstCode(data) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify(data),
	};
	return fetch(endpoints.GST_CODE_CREATE, requestOptions).then(handleResponse);
}

function deleteGstCode(data) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify(data),
	};
	return fetch(endpoints.GST_CODE_DELETE, requestOptions).then(handleResponse);
}

export default gstCodeServices;
